import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { DataService } from '../../services/data.service';
import { Observable } from 'rxjs';

@Injectable()
export class ModifyAmicoFedeleResolver implements Resolve<any> {

  constructor(private dataService: DataService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    let id = route.paramMap.get('id');
    return this.dataService.getAmicoFedele(id);
  }
}
